const DEV = import.meta.env.DEV;
const PROD = import.meta.env.PROD;
const PACKAGE_VERSION = import.meta.env.PACKAGE_VERSION;

export const ENV_CONFIG = { DEV, PROD, PACKAGE_VERSION };
